import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, ViewRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Dropdown } from '../../model/dropdown';
import { LifeStyleQuestion } from 'src/app/pages/medical-underwriting/model';
import { Tooltip } from 'src/app/model/tooltip';
import { EmitterToCtlTypeModel, MedicationQuestionStoreModel, AccordQuestionStoreModel } from 'src/app/pages/medical-underwriting/model/mcUserJourney.model';
import { UtilityServiceForMedicalService } from 'src/app/pages/medical-underwriting/services/utility-service';
import { UtilService } from 'src/app/shared';
import { Subscription } from 'rxjs/Subscription';
import { Router } from '@angular/router';


@Component({
  selector: 'app-dropdown-standard',
  templateUrl: './dropdown-standard.component.html',
  styleUrls: ['./dropdown-standard.component.scss']
})
export class DropdownStandrdComponent implements OnInit {
  @Input() dropdownList: string[];
  selectedOption: string;
  @Input() question: LifeStyleQuestion;
  @Input() label: string;
  @Input() parent: UntypedFormGroup;
  @Input() editMode: boolean;
  controlName: string;
  @Input() indexToAppend: number;
  @Input() objToReferToRetainValueFromTabSquare: MedicationQuestionStoreModel;
  @Input() objToReferForAccord: AccordQuestionStoreModel;
  @Output() selectedValChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() editModelHandler: EventEmitter<any> = new EventEmitter();
  @Input() accordIndexToAppend: number;
  @Input() emitAccordionTitleFromChild: boolean;
  @Output() onDisplayMobileTooltipEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Input()  pageName;
  domId: string;
  subscription: Subscription;
  constructor(private fb: UntypedFormBuilder, private cdRef: ChangeDetectorRef, private utilService: UtilService,public router: Router,
    private utilityServiceForMedicalService: UtilityServiceForMedicalService) {
    this.subscription = this.utilService.emitDropdown.subscribe(val => {
      if (this.cdRef && !(this.cdRef as ViewRef).destroyed) {
        this.cdRef.detectChanges();
      }
    });
  }

  ngOnInit() {
    this.domId = this.utilityServiceForMedicalService.getDomId(this.question.id, this.accordIndexToAppend, this.indexToAppend);
    this.controlName = this.utilityServiceForMedicalService.getControlName(this.question.id, this.accordIndexToAppend);
    if (this.objToReferForAccord) {
      this.question.responseValueByUser = this.utilityServiceForMedicalService.getResponseValueFromRefObj(this.objToReferForAccord, this.question.id, this.accordIndexToAppend);
    }
    this.dropdownList = this.question.responseValue ? this.question.responseValue : [];
    this.selectedOption = this.question.responseValueByUser ? this.question.responseValueByUser : "";
    this.setValueForDropDown(this.question, this.selectedOption);
    if (this.selectedOption) { // emitter needs some time to render the dependent questions for given answer on load.
      setTimeout(() => {
        this.selectedValChange.emit(new EmitterToCtlTypeModel(this.selectedOption, false,
          this.objToReferToRetainValueFromTabSquare, this.accordIndexToAppend, this.objToReferForAccord));
      }, 300);
    }
    this.emitAccordTittleEvent();
  }

  emitAccordTittleEvent() {
    if (this.emitAccordionTitleFromChild && this.selectedOption && (this.accordIndexToAppend || this.accordIndexToAppend === 0)) {
      let obj = { 'index': this.accordIndexToAppend, tittle: this.selectedOption };
      let accordionTittleEvent = new CustomEvent("accordionTittleEvent", { detail: obj });
      document.dispatchEvent(accordionTittleEvent);
    }
  }


  ngOnDestroy(): void {
    if (this.parent.get(this.controlName)) {
      this.parent.get(this.controlName).markAsUntouched();
    }
    this.subscription.unsubscribe();
  }

  setValueForDropDown(question: LifeStyleQuestion, option: string) {
    if (this.parent.controls[this.controlName]) {
      this.parent.controls[this.controlName].setValue(option);
    }
    else {
      this.parent.addControl(this.controlName, this.fb.control(null, question.mandatoryResponse.toUpperCase() === 'YES' ? Validators.required : null));
      this.parent.controls[this.controlName].setValue(option);
    }
  }

  onChangeOfDropdown = (event) => {
    if (this.editMode) { // if (this.editMode && !onPageLoad) {
      const payload = {
        value: this.question
      };
      if (!this.subscription) {
        this.subscription = this.utilService.updateEditForm.subscribe(res => {
          if (res) {
            this.editMode = false;
            this.onChangeOfDropdown(event);
          }
        });
      }
      this.editModelHandler.emit(payload);
    } else {
      this.setValueForDropDown(this.question, this.selectedOption);
      this.emitAccordTittleEvent();
      this.selectedValChange.emit(new EmitterToCtlTypeModel(this.selectedOption,
        true, this.objToReferToRetainValueFromTabSquare, this.accordIndexToAppend, this.objToReferForAccord));
    }
  }

  initializeToolTipDateComp(questionObj: LifeStyleQuestion): Tooltip {
    return new Tooltip(questionObj.helpText, '', false);
  }

  displayMobileTooltipReceiver(){
    this.onDisplayMobileTooltipEmitter.emit();
  }

}